export default "__VITE_ASSET__be01e254__"